
export default function ServicesSection() {
  const services = [
    {
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F67d9f36a18744718ab589f35fef9791e&methods=resize%2C600%2C5000',
      title: 'INTERIOR DECORATION',
      description: 'Get the results you deserve with this quality service, and at an affordable price too! As professional <strong>painters in Watford</strong>, we bring our experience and know-how with us on every job. But what really sets our <strong>painting services</strong> apart from the rest of the industry is our attention to detail and receptiveness to the unique needs of each client in <strong>Hertfordshire</strong>.',
    },
    {
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F13d27b49e11044798f33af16a1fac5f8&methods=resize%2C600%2C5000',
      title: 'EXTERIOR PAINTING',
      description: 'Are you interested in working with professional <strong>painters and decorators in Watford</strong>? We supply all the equipment and skills necessary to tackle just about every type of job our clients have, no matter how big or small it may be. We are always committed to providing consistently reliable <strong>exterior painting services</strong> in a timely and professional manner across <strong>Rickmansworth</strong> and surrounding areas.',
    },
    {
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F374b440feaeb486a91e897d02d5e56a1&methods=resize%2C600%2C5000',
      title: 'WALLPAPER SERVICES',
      description: 'This is a shining example of how our <strong>decorating services in Hertfordshire</strong> have evolved to the high standard we currently hold. It really highlights our professional work ethic and the adjustments we can make to accommodate each client in <strong>Watford</strong>. Nothing is too much for our experienced <strong>decorators</strong> to handle, or too small to push aside.',
    },
    {
      image: 'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F2a86e633d20041a9ae235d807ee0733d&methods=resize%2C600%2C5000',
      title: 'COLOUR CONSULTATION',
      description: 'Get this service done quickly and efficiently with Brushour. We understand how important it is to feel confident and worry-free when it comes to the <strong>painter in Watford</strong> you choose. That\'s why we invest the time and energy necessary to be well prepared for any unique requests or special concerns our <strong>Hertfordshire</strong> clients may have regarding their <strong>painting project</strong>.',
    },
    {
      image: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/53968bf0718bb5d3bdac598784c0fb87.jpeg',
      title: 'LIMEWASH PAINTING',
      description: 'Experience the timeless beauty of <strong>limewash painting in Watford</strong>, a traditional technique that creates a unique, breathable finish perfect for both period properties and modern homes across <strong>Hertfordshire</strong>. This eco-friendly option provides a soft, matte appearance with natural color variations that age beautifully over time, making it ideal for <strong>Rickmansworth</strong> and <strong>Chorleywood</strong> properties.',
    },
    {
      image: 'https://public.readdy.ai/ai/img_res/32d70e78e67c77e47f2a189413069507.jpg',
      title: 'SPRAY PAINTING',
      description: 'Achieve a flawless, factory-like finish with our professional <strong>spray painting services in Watford</strong>. Ideal for large areas, cabinets, furniture, and intricate surfaces across <strong>Hertfordshire</strong>, spray painting delivers superior coverage and a smooth, even coat in less time than traditional methods. Our expert <strong>painters and decorators</strong> use advanced techniques for perfect results.',
    },
  ];

  return (
    <section className="py-12 px-6 bg-white">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm font-medium tracking-widest uppercase mb-3">Our Expertise</p>
          <h1 className="text-4xl md:text-5xl font-bold text-neutral-800 mb-5 leading-tight">
            Local Painters and Decorators in Watford
          </h1>
          <div className="w-16 h-0.5 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-base text-neutral-600 max-w-3xl mx-auto leading-relaxed">
            Professional <strong>painting and decorating services</strong> for homes and businesses across <strong>Watford</strong>, <strong>Rickmansworth</strong>, <strong>Chorleywood</strong>, and surrounding <strong>Hertfordshire</strong> areas. Trusted by 500+ happy customers with 18+ years of experience delivering exceptional results.
          </p>
        </div>

        {/* Top 2 large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {services.slice(0, 2).map((service, index) => (
            <article
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-amber-100/60"
            >
              <div className="w-full h-60 overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title} - Professional painting and decorating services in Watford and Hertfordshire`}
                  title={`${service.title} by Brushour Painters`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 border-t-2 border-amber-400">
                <h3 className="text-sm font-bold tracking-widest text-amber-600 uppercase mb-2">
                  {service.title}
                </h3>
                <p
                  className="text-sm text-neutral-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
              </div>
            </article>
          ))}
        </div>

        {/* Bottom 4 smaller cards in 2x2 grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services.slice(2).map((service, index) => (
            <article
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-amber-100/60 flex flex-col"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title} - Professional painting and decorating services in Watford and Hertfordshire`}
                  title={`${service.title} by Brushour Painters`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 border-t-2 border-amber-400 flex-1 flex flex-col">
                <h3 className="text-xs font-bold tracking-widest text-amber-600 uppercase mb-2">
                  {service.title}
                </h3>
                <p
                  className="text-xs text-neutral-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: service.description }}
                />
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center bg-white rounded-xl border border-amber-100 px-8 py-10 shadow-sm">
          <p className="text-base text-neutral-600 mb-6 max-w-2xl mx-auto leading-relaxed">
            Looking for reliable <strong>painters and decorators in Watford</strong>? Brushour serves all <strong>Hertfordshire</strong> areas including <strong>Rickmansworth</strong>, <strong>Northwood</strong>, <strong>Pinner</strong>, <strong>Bushey</strong>, and <strong>Radlett</strong>. Get your free quote today!
          </p>
          <a
            href="tel:+441234567890"
            className="inline-flex items-center gap-2 px-8 py-4 bg-amber-600 text-white text-base font-semibold rounded-lg hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-xl"></i>
            Get Your Free Quote
          </a>
        </div>

      </div>
    </section>
  );
}
